import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function SearchProducts() {
  const navigate = useNavigate();


const allProducts = [
  { id: "am28", name: "AC Tubular", link: "/product/tubular/ac" },
  { id: "am28dc", name: "DC Tubular", link: "/product/tubular/dc" },
  { id: "venetian", name: "Venetian", link: "/product/venetian/default" },
  { id: "curtain", name: "Curtain Motor", link: "/product/curtain/default" },
  { id: "transmitter", name: "Remote Controller", link: "/product/control/RemoteController" },
  { id: "receiver", name: "Radio Receiver", link: "/product/control/receiver" },
  { id: "am28a", name: "AM28", link: "/product/tubular/ac/am28/AM28" },
  { id: "am35-1", name: "AM35", link: "/product/tubular/ac/AM35" },
  { id: "am45-1", name: "AM45", link: "/product/tubular/ac/am45" },
  { id: "am60-1", name: "AM60", link: "/product/tubular/ac/am60" },
  { id: "am25", name: "AM25", link: "/product/tubular/dc/am25/AM25-1-2-30-es-e" },
  { id: "am28dc2", name: "AM28 (DC)", link: "/product/tubular/dc/am28/AM28-1-8-30-es-e" },
  { id: "am24-1", name: "AM24", link: "/product/venetian/default/AM24/default" },
  { id: "am24-2", name: "AM24tdbu", link: "/product/venetian/default/AM24tdbu/default" },
  { id: "am24-3", name: "AM24Sky", link: "/product/venetian/default/AM24sky/default" },
  { id: "lm100", name: "LM100", link: "/product/curtain/default/LM100/default" },
  { id: "am68", name: "AM68", link: "/product/curtain/default/AM68/default" },
  { id: "am75-1", name: "AM75", link: "/product/curtain/default/AM75/default" },
  { id: "am75-2", name: "AM75 WiFi", link: "/product/curtain/default/AM75-wifi/default" },
  { id: "am93", name: "AM93", link: "/product/curtain/default/AM93/default" },
  { id: "am95", name: "AM95", link: "/product/curtain/default/AM95/default" },
  { id: "am98", name: "AM98", link: "/product/curtain/default/AM98/default" },
  { id: "ac123", name: "AC123", link: "/product/control/RemoteController/AC123/default" },
  { id: "ac133", name: "AC133", link: "/product/control/RemoteController/AC133/default" },
  { id: "ac153", name: "AC153", link: "/product/control/RemoteController/AC153/default" },
  { id: "ac140", name: "AC140", link: "/product/control/RemoteController/AC140/default" },
  { id: "ac152", name: "AC152", link: "/product/control/RemoteController/AC152/default" },
  { id: "rr433", name: "RR433", link: "/product/control/receiver/RR433/default" },
  { id: "ac408-02", name: "AC408-02", link: "/product/control/receiver/AC408/default" },
];

  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const filtered =
    query.trim() === ""
      ? []
      : allProducts.filter((p) =>
          p.name.toLowerCase().includes(query.toLowerCase())
        );


  const handleKeyDown = (e) => {
    if (e.key === "Enter" && filtered.length > 0) {
      navigate(filtered[0].link);
      setQuery(""); 
      setOpen(false); 
    }
  };


  const handleSelect = (link) => {
    navigate(link);
    setQuery(""); 
    setOpen(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: 36,
          height: 36,
          borderRadius: 6,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: 18,
        }}
      >
        <svg
          style={{ paddingTop: "25px" }}
          xmlns="http://www.w3.org/2000/svg"
          color="white"
          width="45"
          height="45"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m21 21-4.34-4.34" />
          <circle cx="11" cy="11" r="8" />
        </svg>
      </button>

      {open && (
        <div style={{ position: "absolute", top: "110%", right: 0 }}>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Product Name"
            style={{
              padding: 8,
              borderRadius: 6,
              border: "1px solid #ccc",
              fontSize: 16,
              width: 220,
            }}
          />

          {filtered.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "110%",
                left: 0,
                width: "220px",
                background: "#fff",
                border: "1px solid #ddd",
                borderRadius: 6,
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                zIndex: 1000,
              }}
            >
              {filtered.map((p) => (
                <div
                  key={p.id}
                  onClick={() => handleSelect(p.link)}
                  style={{
                    display: "block",
                    padding: "8px 10px",
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "#333",
                  }}
                >
                  {p.name}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
